export default {
      id: "icon-arrow-link-usage",
      viewBox: "0 0 20 21",
      url: "../icon/" + "icons.svg#icon-arrow-link-usage",
      toString: function () {
        return this.url;
      }
    }